import { createContext, useEffect } from "react";
import { useSelector } from "react-redux";
import i18n from "@i18n";

const LanguageContext = createContext({
  preferredLanguage: "en",
});

const isReactNative = typeof document === "undefined";

function ProviderLanguage(props: any) {
  const preferredLanguage = useSelector((state: any) => state.preferredLanguage);

  useEffect(() => {
    const isRTL = preferredLanguage === "ar";
    props.isRTLCallback?.(isRTL);
    i18n.changeLanguage(preferredLanguage);
    if (!isReactNative) {
      globalThis.localStorage.setItem("preferredLanguage", preferredLanguage);
    }
  }, [preferredLanguage]);

  const Provider = LanguageContext.Provider as any;
  return (
    <Provider
      value={{
        preferredLanguage,
      }}
    >
      {props.children}
    </Provider>
  );
}

export default ProviderLanguage;
